import { Types } from '../Constants/Types';
import { Dispatch } from 'redux';
import AuthTypes from '../Interfaces/auth-interface';
import { client } from '../Contexts/GraphqlContext';
import { NavigateFunction } from 'react-router-dom';
import {
  info,
  infoDriver,
  loginAdmin,
  logoutGql,
  mutationLoginDriver,
  mutationLogoutDriver,
} from '../GraphQL/auth.graphql';
import { AppRoutes } from '../Constants/Routes';
import { buildAbility } from '../Contexts/CaslContext';
import { getFirstAccessibleRoute } from '../Utilities/firstAccessibleRoute';

export const login =
  (
    loginAdminInput: AuthTypes['loginInput'],
    navigate: NavigateFunction,
    func: () => void,
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: Types.S_LOADING });
      const { data } = await client.mutate({
        mutation: loginAdmin,
        variables: { loginAdminInput },
      });
      dispatch({ type: Types.LOGIN, payload: data.loginAdmin });
      dispatch({ type: Types.E_LOADING });
      const ability = buildAbility(data.loginAdmin);
      navigate(getFirstAccessibleRoute(ability), { replace: true });
      func();
    } catch ({ message }: any) {
      dispatch({ type: Types.AUTH_ERROR, payload: message });
      dispatch({ type: Types.E_LOADING });
    }
  };

export const getInfo =
  () =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: Types.START_INFO_LOADING });
      const { data } = await client.query({ query: info });
      dispatch({ type: Types.INFO, payload: data.infoAdmin });
      dispatch({ type: Types.END_INFO_LOADING });
    } catch {
      dispatch({ type: Types.END_INFO_LOADING });
      if (typeof window !== 'undefined' && window.location.pathname === AppRoutes.login) {
        dispatch({ type: Types.LOGOUT, payload: null });
      }
    }
  };

export const logout =
  (navigate: NavigateFunction) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: Types.LOGOUT, payload: null });
      dispatch({ type: Types.START_INFO_LOADING });
      await client.mutate({ mutation: logoutGql });
      dispatch({ type: Types.END_INFO_LOADING });
      navigate(AppRoutes.login, { replace: true });
    } catch (error) {
      dispatch({ type: Types.END_INFO_LOADING });
      dispatch({ type: Types.LOGOUT, payload: null });
      console.log(error);
    }
  };

// =================================
//* Drivers
// =================================

export const loginDriver =
  (
    loginDriverInput: AuthTypes['loginInput'],
    navigate: NavigateFunction,
    func: () => void,
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: Types.S_LOADING });
      const { data } = await client.mutate({
        mutation: mutationLoginDriver,
        variables: { loginDriverInput },
      });
      dispatch({ type: Types.LOGIN, payload: data.loginDriver });
      dispatch({ type: Types.E_LOADING });
      const ability = buildAbility(data.loginDriver);
      navigate(getFirstAccessibleRoute(ability), { replace: true });
      func();
    } catch ({ message }: any) {
      dispatch({ type: Types.AUTH_ERROR, payload: message });
      dispatch({ type: Types.E_LOADING });
    }
  };

export const getInfoDriver =
  () => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: Types.START_INFO_LOADING });
      const { data } = await client.query({ query: infoDriver });
      dispatch({ type: Types.INFO, payload: data.infoDriver });
      dispatch({ type: Types.END_INFO_LOADING });
    } catch {
      dispatch({ type: Types.END_INFO_LOADING });
      if (typeof window !== 'undefined' && window.location.pathname === AppRoutes.login) {
        dispatch({ type: Types.LOGOUT, payload: null });
      }
    }
  };

export const logoutDriver =
  (navigate: NavigateFunction) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: Types.LOGOUT, payload: null });
      dispatch({ type: Types.START_INFO_LOADING });
      await client.mutate({ mutation: mutationLogoutDriver });
      dispatch({ type: Types.END_INFO_LOADING });
      navigate(AppRoutes.login, { replace: true });
    } catch (error) {
      dispatch({ type: Types.END_INFO_LOADING });
      dispatch({ type: Types.LOGOUT, payload: null });
      console.log(error);
    }
  };
